import { css } from '@emotion/react'

export const extendedStyles = css({
    fontSize: 24,
    lineHeight: '24px',
})

export const rootStyles = css({
    display: 'flex',
    background: '#111',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'translate3d(0,0,0)',
    overflow: 'hidden',
    cursor: 'pointer',
    fontSize: '0.8125rem',
})
